enum ChargingConfigurationStatus {
    ACCEPTED = 'ACCEPTED',
    SENDING = 'SENDING',
    REJECTED = 'REJECTED',
    NOT_SENT_YET = 'NOT_SENT_YET',
}

export default ChargingConfigurationStatus;
